module.exports = __webpack_public_path__ + "img/duoren_icon.1d7e7717.png";